import type { Geofence, GeoJsonFeatureCollection, LatLngBounds } from '@gpx-spa/geo-domain'
import { geofenceBounds, latLngBoundsFromPoints } from '@gpx-spa/geo-domain'

/** Axis-aligned bounds containing a circle of `radiusM` meters around (lat, lng). */
export function boundsAroundCircleMeter(lat: number, lng: number, radiusM: number): LatLngBounds {
  const mPerDegLat = 111_320
  const cosLat = Math.cos((lat * Math.PI) / 180)
  const dLat = radiusM / mPerDegLat
  const dLng = radiusM / (mPerDegLat * Math.max(1e-6, Math.abs(cosLat)))
  return {
    southWest: { lat: lat - dLat, lng: lng - dLng },
    northEast: { lat: lat + dLat, lng: lng + dLng },
  }
}

/**
 * Bounds to frame a stop: geofence outline when present and valid, else a meter-radius circle around the point.
 */
export function boundsForStopGeofenceOrRadius(
  geofence: Geofence | null | undefined,
  coords: { lat: number; lng: number } | undefined,
  radiusM: number
): LatLngBounds | null {
  if (geofence) {
    const bb = geofenceBounds(geofence)
    if (bb) return bb
  }
  if (coords != null && Number.isFinite(coords.lat) && Number.isFinite(coords.lng)) {
    return boundsAroundCircleMeter(coords.lat, coords.lng, radiusM)
  }
  return null
}

export function circleStopFeature(
  lat: number,
  lng: number,
  radiusM: number,
  mapStyle: Record<string, unknown>
): GeoJsonFeatureCollection['features'][0] {
  return {
    type: 'Feature',
    properties: {
      type: 'circle',
      center: [lng, lat] as [number, number],
      radius: radiusM,
      map: mapStyle,
    },
    geometry: {
      type: 'Point',
      coordinates: [lng, lat],
    },
  }
}

export function boundsFromLngLats(points: Array<{ lat: number; lng: number }>): LatLngBounds | null {
  return latLngBoundsFromPoints(points)
}
